// extracted by mini-css-extract-plugin
export default {"root":"otpScreen_root__A7+3x","top":"otpScreen_top__Xlyn1","otp":"otpScreen_otp__6QKeq","form":"otpScreen_form__TX8Zt"};